import { useTranslation } from 'react-i18next';

import { useMediaPreview } from '@/components/question/forms/shared/useMediaPreview';
import CoverImageInput from '@/components/shared/CoverImageInput';
import { TextInput } from '@/components/ui/daisy';
import {
  MAX_QUIZ_ANSWERS_FILE_SIZE,
  QUIZ_ANSWERS_ACCEPTED_IMAGE_TYPES,
} from '@/constants';
import { QuestionCreateDTO } from '@/models/Answer';

type QuestionColumnItemMediaProps = {
  item: QuestionCreateDTO;
  onUpdateMedia: (file: File | string, altText?: string) => void;
};

export default function QuestionColumnItemMedia({
  item,
  onUpdateMedia,
}: QuestionColumnItemMediaProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.questionsTab.createQuestionModal.questionForm',
  });

  const previewUrl = useMediaPreview(item.mediaFile);
  const currentAltText = item.altText ?? '';

  const handleImageChange = (url: string) => {
    if (!url) onUpdateMedia('', currentAltText);
  };

  const handleFileSelect = (file: File) => {
    onUpdateMedia(file, currentAltText);
  };

  const handleAltTextChange = (altText: string) => {
    onUpdateMedia(item.mediaFile ?? '', altText);
  };

  return (
    <div className="flex items-end gap-3 w-full">
      <CoverImageInput
        value={previewUrl ?? undefined}
        onChange={handleImageChange}
        onFileSelect={handleFileSelect}
        accept={QUIZ_ANSWERS_ACCEPTED_IMAGE_TYPES}
        limit={MAX_QUIZ_ANSWERS_FILE_SIZE}
        hideTrashButton
      />
      <TextInput
        value={currentAltText}
        placeholder={t('altTextPlaceholder')}
        className="w-full"
        onChange={e => handleAltTextChange(e.target.value)}
      />
    </div>
  );
}
